<template>
    <section class="inner-article-container">
        <div class="page-container">
            <div class="heading">
                <h2 class="heading__h3 left">{{this.categoryTitle}}</h2>
                <div class="right">
                    <a @click="navigateToCategoriesSearch" class="button pink smallsize small">View all</a>

                </div>

            </div>
            <div class="article-detais-view">

                <offers-block-component :view="'block'" :key="item.OfferId" :offer="item" v-for="(item, index) in this.matchedOffers"> </offers-block-component>

            </div>
        </div>
    </section>
</template>

<script>
    import OffersBlockComponent from './OffersBlockComponent.vue'
    export default {
    components: { OffersBlockComponent },
        name: "CategoryOffersComponent",
        props: ['matchedOffers', 'category', 'categoryTitle'],
        data() {
            return{

            }
        },
        methods: {
            navigateToCategoriesSearch () {
                let routeData = this.$router.resolve({name: 'search-results', query: {category: this.category}});
                window.open(routeData.href, '_self');
            }
        },
        watch: {
            matchedOffers: function (val) {
                // console.log(val, 'matched offers');
            }
        }
    }
</script>
